<script>
import { appConfig } from '@src/app.config'

import Layout from '@layouts/main'
import { services } from '@utils/common-services'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: { Layout },
  data() {
    return {
      menu: null,
    }
  },

  beforeMount() {
    this.getMenu()
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'menu_list' } })
    var doc = this.$refs.home
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getMenu() {
      // console.log(state.userDetails)
      var role = services.decodeJWT(services.getAuth()).role_id

      this.$store
        .dispatch('jv/get', [
          'menu_list',
          {
            url: '/system/menu/' + role,
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((data) => {
          this.menu = data._jv.attrs.config
          // console.log(data)
          //  var check=this.$store.getters['jv/get']('menu_list')
          // var id= Object.keys(check)
          // console.log(check[id].config)
        })
    },
  },
}
</script>

<template>
  <div v-if="menu !== null" ref="home">
    <Layout :menu="menu">
      <transition>
        <router-view> </router-view>
      </transition>
    </Layout>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
